import { render, staticRenderFns } from "./NeuroSummary.vue?vue&type=template&id=425ad1a6&"
import script from "./NeuroSummary.vue?vue&type=script&lang=ts&"
export * from "./NeuroSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425ad1a6')) {
      api.createRecord('425ad1a6', component.options)
    } else {
      api.reload('425ad1a6', component.options)
    }
    module.hot.accept("./NeuroSummary.vue?vue&type=template&id=425ad1a6&", function () {
      api.rerender('425ad1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/NeuroSummary.vue"
export default component.exports